@if (commonService.isLoggedIn()) {
  <app-dashboard [currentUser]="currentUser" [groupingItemName]="currentUser?.HomeStationName">
  </app-dashboard>
}
